export interface FormError {
  loading: boolean;
  errorMessage: string;
  setErrors (data:any) :void;
}

export class ErrorHandler {
  constructor (reference:FormError, e:any) {
    reference.loading = false;
    if (e.response && e.response.data) {
      if (e.response.data.message) {
        reference.errorMessage = e.response.data.message;
      }
      reference.setErrors(e.response.data.data);
    } else {}
  }
}
